import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconClipboards = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M18.572 2.571a3 3 0 0 1 3 3v10.93a3 3 0 0 1-3 3H10a3 3 0 0 1-3-3V5.571a3 3 0 0 1 3-3zm-6.642.215a1.572 1.572 0 0 0-1.556 1.785H10a1 1 0 0 0-1 1v10.93a1 1 0 0 0 1 1h8.572a1 1 0 0 0 1-1V5.571a1 1 0 0 0-1-1H18.2q.016-.105.017-.214c0-.868-.704-1.57-1.572-1.57z"
    />
    <path
      fill="currentColor"
      d="M6 8a1 1 0 0 0-1 1v10.93a1 1 0 0 0 1 1h8.572a1 1 0 0 0 .717-.304h2.2a3 3 0 0 1-2.917 2.304H6a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3z"
    />
    <rect width={8} height={3} x={10.407} y={2} stroke="currentColor" strokeWidth={1.5} rx={1} />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11.407 10h6M11.407 14h6"
    />
  </NcIcon>
);
export { NcIconClipboards };
